var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2275 0C14.4346 0 14.6025 0.167893 14.6025 0.375C14.6025 0.582107 14.4346 0.75 14.2275 0.75L10.7845 0.75C12.7492 2.07069 14.1239 4.20293 14.4276 6.66802C14.4529 6.87357 14.3068 7.06073 14.1013 7.08605C13.8957 7.11138 13.7086 6.96527 13.6832 6.75972C13.4075 4.52137 12.1605 2.58243 10.3755 1.37875L10.3755 4.60205C10.3755 4.80916 10.2076 4.97705 10.0005 4.97705C9.79338 4.97705 9.62549 4.80916 9.62549 4.60205V0.375C9.62549 0.167893 9.79338 0 10.0005 0H14.2275Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32409 9.23149C2.29877 9.02594 2.11161 8.87984 1.90606 8.90516C1.7005 8.93048 1.5544 9.11764 1.57972 9.32319L2.32409 9.23149ZM5.60841 15.4854C5.78633 15.5914 6.01649 15.5331 6.1225 15.3552C6.22851 15.1773 6.17021 14.9471 5.99229 14.8411L5.60841 15.4854ZM1.77979 15.2412C1.57268 15.2412 1.40479 15.4091 1.40479 15.6162C1.40479 15.8233 1.57268 15.9912 1.77979 15.9912L1.77979 15.2412ZM6.00684 15.6162L6.00684 15.9912C6.1063 15.9912 6.20168 15.9517 6.272 15.8814C6.34233 15.8111 6.38184 15.7157 6.38184 15.6162H6.00684ZM6.38184 11.3892C6.38184 11.1821 6.21395 11.0142 6.00684 11.0142C5.79973 11.0142 5.63184 11.1821 5.63184 11.3892H6.38184ZM1.57972 9.32319C1.90288 11.9466 3.43912 14.193 5.60841 15.4854L5.99229 14.8411C4.01574 13.6635 2.61803 11.6176 2.32409 9.23149L1.57972 9.32319ZM1.77979 15.9912L6.00684 15.9912L6.00684 15.2412L1.77979 15.2412L1.77979 15.9912ZM6.38184 15.6162V11.3892H5.63184V15.6162H6.38184Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.61426,
    y: 8.61621,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.393555 1.38025C0.393555 0.827964 0.84127 0.380249 1.39355 0.380249H6.39355C6.94584 0.380249 7.39355 0.827964 7.39355 1.38025V6.38025C7.39355 6.93253 6.94584 7.38025 6.39355 7.38025H1.39355C0.84127 7.38025 0.393555 6.93253 0.393555 6.38025V1.38025Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.691814bcd040bd328e864371dd0d5af4.svg";
export { ForwardRef as ReactComponent };